
export const apiUrl = "https://api.victor.ziz.co.ke/api"
export const socketsApiUrl = "wss://api.victor.ziz.co.ke"
